// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TemplateManager_templateManager__QTa0y {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}
.TemplateManager_templateManager__QTa0y h2 {
  margin-bottom: 20px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_addButton__sndxC {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_addButton__sndxC:hover {
  background-color: #0056b3;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA {
  list-style: none;
  padding: 0;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #f9f9f9;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateContent__HH6EC {
  flex: 1 1;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateContent__HH6EC h3 {
  margin: 0;
  font-size: 1.2em;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateContent__HH6EC p {
  margin: 5px 0 0;
  color: #555;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateContent__HH6EC .TemplateManager_automationInfo__Gz6MZ {
  display: grid;
  gap: 4px;
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #dbeafe;
  border-radius: 6px;
  background: #eff6ff;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateContent__HH6EC .TemplateManager_automationInfo__Gz6MZ p {
  margin: 0;
  color: #1e3a8a;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateActions__4wdJb {
  display: flex;
  gap: 10px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateActions__4wdJb button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2em;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateActions__4wdJb button.TemplateManager_editButton__dcu0F {
  color: #007bff;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateActions__4wdJb button.TemplateManager_editButton__dcu0F:hover {
  color: #0056b3;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateActions__4wdJb button.TemplateManager_deleteButton__uBzLA {
  color: #ff0000;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_templateList__qeFyA .TemplateManager_templateItem__G4BJb .TemplateManager_templateActions__4wdJb button.TemplateManager_deleteButton__uBzLA:hover {
  color: #cc0000;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy h3 {
  margin-bottom: 20px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_formGroup__LTweV {
  margin-bottom: 15px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_formGroup__LTweV label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_formGroup__LTweV .TemplateManager_inputField__hi6Hn, .TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_formGroup__LTweV .TemplateManager_textareaField__phV3M {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_formGroup__LTweV .TemplateManager_textareaField__phV3M {
  resize: vertical;
  min-height: 100px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_modalActions__yjqiv {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_modalActions__yjqiv button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_modalActions__yjqiv button.TemplateManager_saveButton__Y8dPN {
  background-color: #007bff;
  color: white;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_modalActions__yjqiv button.TemplateManager_saveButton__Y8dPN:hover {
  background-color: #0056b3;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_modalActions__yjqiv button.TemplateManager_cancelButton__bmsZI {
  background-color: #ccc;
}
.TemplateManager_templateManager__QTa0y .TemplateManager_modalOverlay__q3Q\\+e .TemplateManager_modalContent__DGRSy .TemplateManager_modalActions__yjqiv button.TemplateManager_cancelButton__bmsZI:hover {
  background-color: #bbb;
}
@media (max-width: 768px) {
  .TemplateManager_templateManager__QTa0y {
    padding: 10px;
  }
  .TemplateManager_templateManager__QTa0y .TemplateManager_templateItem__G4BJb {
    flex-direction: column;
    align-items: flex-start;
  }
  .TemplateManager_templateManager__QTa0y .TemplateManager_templateItem__G4BJb .TemplateManager_templateActions__4wdJb {
    margin-top: 10px;
  }
}

.TemplateManager_formGroup__LTweV {
  margin-bottom: 15px;
}
.TemplateManager_formGroup__LTweV label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.TemplateManager_formGroup__LTweV .TemplateManager_inputField__hi6Hn, .TemplateManager_formGroup__LTweV .TemplateManager_textareaField__phV3M {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
}
.TemplateManager_formGroup__LTweV .TemplateManager_textareaField__phV3M {
  resize: vertical;
  min-height: 100px;
}
.TemplateManager_formGroup__LTweV select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  background-color: white;
}

.TemplateManager_formGroup__LTweV {
  margin-bottom: 15px;
}
.TemplateManager_formGroup__LTweV label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.TemplateManager_formGroup__LTweV .TemplateManager_inputField__hi6Hn, .TemplateManager_formGroup__LTweV .TemplateManager_textareaField__phV3M, .TemplateManager_formGroup__LTweV select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  background-color: white;
}
.TemplateManager_formGroup__LTweV .TemplateManager_textareaField__phV3M {
  resize: vertical;
  min-height: 100px;
}
.TemplateManager_formGroup__LTweV select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/TemplateManager/TemplateManager.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAIE;EACE,gBAAA;EACA,UAAA;AAFJ;AAII;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAFN;AAIM;EACE,SAAA;AAFR;AAIQ;EACE,SAAA;EACA,gBAAA;AAFV;AAKQ;EACE,eAAA;EACA,WAAA;AAHV;AAMQ;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAJV;AAMU;EACE,SAAA;EACA,cAAA;AAJZ;AASM;EACE,aAAA;EACA,SAAA;AAPR;AASQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAPV;AASU;EACE,cAAA;AAPZ;AASY;EACE,cAAA;AAPd;AAWU;EACE,cAAA;AATZ;AAWY;EACE,cAAA;AATd;AAiBE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAfN;AAiBM;EACE,mBAAA;AAfR;AAkBM;EACE,mBAAA;AAhBR;AAkBQ;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAhBV;AAmBQ;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAjBV;AAoBQ;EACE,gBAAA;EACA,iBAAA;AAlBV;AAsBM;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AApBR;AAsBQ;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AApBV;AAsBU;EACE,yBAAA;EACA,YAAA;AApBZ;AAsBY;EACE,yBAAA;AApBd;AAwBU;EACE,sBAAA;AAtBZ;AAwBY;EACE,sBAAA;AAtBd;AA8BE;EA7KF;IA8KI,aAAA;EA3BF;EA6BE;IACE,sBAAA;IACA,uBAAA;EA3BJ;EA6BI;IACE,gBAAA;EA3BN;AACF;;AA+BA;EACE,mBAAA;AA5BF;AA8BE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AA5BJ;AA+BE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AA7BJ;AAgCE;EACE,gBAAA;EACA,iBAAA;AA9BJ;AAiCE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AA/BJ;;AAkCA;EACE,mBAAA;AA/BF;AAiCE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AAhCJ;AAmCE;EACE,gBAAA;EACA,iBAAA;AAjCJ;AAoCE;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;AAlCJ","sourcesContent":[".templateManager {\r\n  padding: 20px;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n\r\n  h2 {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .addButton {\r\n    padding: 10px 15px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 20px;\r\n\r\n    &:hover {\r\n      background-color: #0056b3;\r\n    }\r\n  }\r\n\r\n  .templateList {\r\n    list-style: none;\r\n    padding: 0;\r\n\r\n    .templateItem {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      padding: 15px;\r\n      border: 1px solid #ddd;\r\n      border-radius: 8px;\r\n      margin-bottom: 10px;\r\n      background-color: #f9f9f9;\r\n\r\n      .templateContent {\n        flex: 1;\n\r\n        h3 {\r\n          margin: 0;\r\n          font-size: 1.2em;\r\n        }\r\n\r\n        p {\n          margin: 5px 0 0;\n          color: #555;\n        }\n\n        .automationInfo {\n          display: grid;\n          gap: 4px;\n          margin-top: 10px;\n          padding: 10px;\n          border: 1px solid #dbeafe;\n          border-radius: 6px;\n          background: #eff6ff;\n\n          p {\n            margin: 0;\n            color: #1e3a8a;\n          }\n        }\n      }\n\r\n      .templateActions {\r\n        display: flex;\r\n        gap: 10px;\r\n\r\n        button {\r\n          background: none;\r\n          border: none;\r\n          cursor: pointer;\r\n          font-size: 1.2em;\r\n\r\n          &.editButton {\r\n            color: #007bff;\r\n\r\n            &:hover {\r\n              color: #0056b3;\r\n            }\r\n          }\r\n\r\n          &.deleteButton {\r\n            color: #ff0000;\r\n\r\n            &:hover {\r\n              color: #cc0000;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .modalOverlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    .modalContent {\r\n      background-color: white;\r\n      padding: 20px;\r\n      border-radius: 8px;\r\n      width: 90%;\r\n      max-width: 500px;\r\n\r\n      h3 {\r\n        margin-bottom: 20px;\r\n      }\r\n\r\n      .formGroup {\r\n        margin-bottom: 15px;\r\n\r\n        label {\r\n          display: block;\r\n          margin-bottom: 5px;\r\n          font-weight: bold;\r\n        }\r\n\r\n        .inputField, .textareaField {\r\n          width: 100%;\r\n          padding: 10px;\r\n          border: 1px solid #ccc;\r\n          border-radius: 4px;\r\n          font-size: 1em;\r\n        }\r\n\r\n        .textareaField {\r\n          resize: vertical;\r\n          min-height: 100px;\r\n        }\r\n      }\r\n\r\n      .modalActions {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        gap: 10px;\r\n\r\n        button {\r\n          padding: 10px 15px;\r\n          border: none;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n\r\n          &.saveButton {\r\n            background-color: #007bff;\r\n            color: white;\r\n\r\n            &:hover {\r\n              background-color: #0056b3;\r\n            }\r\n          }\r\n\r\n          &.cancelButton {\r\n            background-color: #ccc;\r\n\r\n            &:hover {\r\n              background-color: #bbb;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 10px;\r\n\r\n    .templateItem {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n\r\n      .templateActions {\r\n        margin-top: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n.formGroup {\r\n  margin-bottom: 15px;\r\n\r\n  label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .inputField, .textareaField {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 1em;\r\n  }\r\n\r\n  .textareaField {\r\n    resize: vertical;\r\n    min-height: 100px;\r\n  }\r\n\r\n  select {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 1em;\r\n    background-color: white;\r\n  }\r\n}\r\n.formGroup {\r\n  margin-bottom: 15px;\r\n\r\n  label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .inputField, .textareaField, select {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 1em;\r\n    background-color: white;\r\n  }\r\n\r\n  .textareaField {\r\n    resize: vertical;\r\n    min-height: 100px;\r\n  }\r\n\r\n  select {\r\n    appearance: none; // Убираем стандартный стиль браузера\r\n    background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center;\r\n    background-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateManager": `TemplateManager_templateManager__QTa0y`,
	"addButton": `TemplateManager_addButton__sndxC`,
	"templateList": `TemplateManager_templateList__qeFyA`,
	"templateItem": `TemplateManager_templateItem__G4BJb`,
	"templateContent": `TemplateManager_templateContent__HH6EC`,
	"automationInfo": `TemplateManager_automationInfo__Gz6MZ`,
	"templateActions": `TemplateManager_templateActions__4wdJb`,
	"editButton": `TemplateManager_editButton__dcu0F`,
	"deleteButton": `TemplateManager_deleteButton__uBzLA`,
	"modalOverlay": `TemplateManager_modalOverlay__q3Q+e`,
	"modalContent": `TemplateManager_modalContent__DGRSy`,
	"formGroup": `TemplateManager_formGroup__LTweV`,
	"inputField": `TemplateManager_inputField__hi6Hn`,
	"textareaField": `TemplateManager_textareaField__phV3M`,
	"modalActions": `TemplateManager_modalActions__yjqiv`,
	"saveButton": `TemplateManager_saveButton__Y8dPN`,
	"cancelButton": `TemplateManager_cancelButton__bmsZI`
};
export default ___CSS_LOADER_EXPORT___;
